import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined"
import DoNotDisturb from "@mui/icons-material/DoNotDisturb"
import CancelOutlined from "@mui/icons-material/CancelOutlined"
import DoNotDisturbOnOutlined from "@mui/icons-material/DoNotDisturbOnOutlined"

import moment from "moment"
import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

const statusIconMapping = {
  cancelled_no_show: { Icon: DoNotDisturb, iconColor: "#EE000D" },
  cancelled: { Icon: CancelOutlined, iconColor: "#121212" },
  finished: { Icon: CheckCircleOutlined, iconColor: "#1B8841" },
  pending: { Icon: DoNotDisturbOnOutlined, iconColor: "#FF6600" },
}

const reportStatusMap = {
  cancelled: "Canceled",
  cancelled_no_show: "No Show",
  finished: "Finished",
  pending: "Pending",
}

const EventContent = ({ event }) => {
  const { title, start } = event
  const { status, user_time_zone_abbr } = event.extendedProps
  let comment = reportStatusMap[status] || null
  const iconProps = statusIconMapping[status]
  const { Icon, iconColor } = iconProps || {}

  return (
    <OverlayTrigger overlay={<Tooltip>{comment ? `${title} | ${comment}` : title}</Tooltip>}>
      <div className="fc-content">
        <div className="fc-time">
          <div className="d-inline-flex align-items-end">
            {moment(start).format("hh:mma")}
            {` ${user_time_zone_abbr}`}
            {Icon && (
              <div className="icon-16-px ml-1" style={{ color: iconColor }}>
                <Icon />
              </div>
            )}
          </div>
        </div>
        <div className="fc-title flex-fill">{title}</div>
      </div>
    </OverlayTrigger>
  )
}
export default EventContent
